import type { IncomingHttpHeaders } from "http"

import { CF_RAY_HEADER, REQUEST_ID_HEADER } from "@/modules/fetch/constants"

export const getErrorIdFromHeaders = (headers: IncomingHttpHeaders): string => {
  const rayId = headers[CF_RAY_HEADER] || ""
  const requestId = headers[REQUEST_ID_HEADER] || ""

  if (rayId || requestId) {
    return `${rayId} // ${requestId}`
  }

  return `${Date.now()}-${Math.floor(Math.random() * 1e12)}`
}
